import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-11 «Налаштування» (F-011). Тека с этим файлом — и есть
// регистрация (`../registry.ts`): пункт «Налаштування» раздела «СИСТЕМА» оживает
// вместе с ней (решение 028). Вход — пункт меню, «?» горизонта и подушки `S-01`
// и прямой адрес `/s-11`.
export const meta: SurfaceMeta = {
  code: "S-11",
  // Название — слово словаря по коду (`G117`), читается при показе.
  get title_uk() {
    return w("s11_title");
  },
  path: "/s-11",
};
